import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';
import { TableBookablePeriod } from '@/types/table';

export function bookablePeriodsQueryKey(establishmentId: string | null) {
  return ['bookable-periods', establishmentId] as const;
}

export function useBookablePeriodsQuery(establishmentId: string | null) {
  return useQuery({
    queryKey: bookablePeriodsQueryKey(establishmentId),
    queryFn: async (): Promise<TableBookablePeriod[]> => {
      let query = supabasePublic
        .from('table_bookable_periods')
        .select('*')
        .order('start_date', { ascending: true });
      if (establishmentId) query = query.eq('establishment_id', establishmentId);

      const { data, error } = await query;
      if (error) throw error;

      return (data || []).map((p: any) => ({
        id: p.id,
        tableId: p.table_id,
        establishmentId: p.establishment_id,
        startDate: new Date(p.start_date),
        endDate: new Date(p.end_date),
        reason: p.reason || undefined,
        createdAt: new Date(p.created_at),
      }));
    },
    enabled: Boolean(establishmentId),
    staleTime: 1000 * 60 * 2,
  });
}
